module.exports = __webpack_public_path__ + "static/media/kernelcon_black.9b6b0b35.png";